import createAxiosInstance from './createAxiosInstance'

const path = process.env.VUE_APP_MAPI_URL
const instance = createAxiosInstance(path)

export const mapi = {

  /**
   * 匯出住戶資料
   * @param {Object} params - 查詢參數
   * @param {boolean} params.isOpened - 是否開啟
   * @param {string} params.tag - 標籤
   * @param {boolean} params.isVirtual - 是否虛擬
   * @returns {Promise} 住戶資料匯出檔案
   * @see GET /api/Community/Resident/Export
   * Swagger: {@link https://housekeeper-api-dev.kingnetsmart.com.tw/swagger/index.html#/Community/get_api_Community_Resident_Export}
   */
  exportResident: async ({ isOpened, tag, isVirtual }) => instance.get('/Community/Resident/Export', {
    params: {
      IsOpened: isOpened,
      Tag: tag,
      IsVirtual: isVirtual
    },
    responseType: 'blob'
  })
}
